var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { TraitConditionTopEvaluator } from '../../evaluator/TraitConditionTopEvaluator';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class AttachedTraitCondition {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get trait() {
        return this.at.trait;
    }
    get evaluator() {
        return TraitConditionTopEvaluator.fromSerialized({ parent: this.at });
    }
    get isConditionTrue() {
        if (!this.trait.condition)
            return true;
        return this.evaluator.isConditionTrue;
    }
    get isConditionFalse() {
        return !this.isConditionTrue;
    }
}
__decorate([
    memoize
], AttachedTraitCondition.prototype, "evaluator", null);
